import { Footer } from "../components/Footer";
import { NavBar } from "../components/NavBar";
import { useAuthSessionContext } from "../components/routing/auth-session-store";
export const Layout = ({ children }: { children: React.ReactNode }) => {
	const { session } = useAuthSessionContext();
	return (
		<div className='flex min-h-screen flex-col overflow-x-hidden'>
			{/* NavBar */}
			<NavBar isLogged={Boolean(session)} />
			<main className='min-h-0 flex-1 overflow-x-hidden font-[Inter]'>
				{children}
			</main>
			<Footer />
		</div>
	);
};
